// Define as an enum for runtime use
export enum ApplicationStatus {
  TO_APPLY = 'to_apply',
  APPLIED = 'applied',
  INTERVIEWING = 'interviewing',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  ARCHIVED = 'archived'
}

export interface JobApplication {
  id: number;
  job_id: number;
  user_id: string;
  title: string;
  company: string;
  status: ApplicationStatus;
  updatedAt: string;
  location?: string;
  deadline?: string;
}

export const APPLICATION_STATUSES: Record<ApplicationStatus, ApplicationStatus> = {
  [ApplicationStatus.TO_APPLY]: ApplicationStatus.TO_APPLY,
  [ApplicationStatus.APPLIED]: ApplicationStatus.APPLIED,
  [ApplicationStatus.INTERVIEWING]: ApplicationStatus.INTERVIEWING,
  [ApplicationStatus.ACCEPTED]: ApplicationStatus.ACCEPTED,
  [ApplicationStatus.REJECTED]: ApplicationStatus.REJECTED,
  [ApplicationStatus.ARCHIVED]: ApplicationStatus.ARCHIVED
};